import { Navigate, useLocation } from 'react-router-dom';
import { getV2PatientRedirectPath } from './route-utils';

export default function LegacyPatientRouteRedirect() {
  const { pathname, search, hash } = useLocation();
  const targetPath = getV2PatientRedirectPath(pathname);

  return <Navigate to={`${targetPath}${search}${hash}`} replace />;
}
